/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormControl } from "@angular/forms";

export function EmailValidator(control: FormControl): { [key: string]: any } | null {
    const email = control.value;
    const domainRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!domainRegex.test(email)) {
        return { invalidEmail: true };
    }

    return null;
}
